import {
    AUTH_GEO_USER,
    AUTH_LOGIN,
    AUTH_LOGIN_ERROR, AUTH_signout,
    getLoginUser,
    getUserToken, HOUSING_SCHEME_BOUNDARY, removeTokenUser,
    SET_LOADER,
    setLocalUser,
    setToken, UPDATE_AUTH_USER
} from "../variables";
import ApiAuth from "../../API/ApiAuth";

const initialState = {
    user: getLoginUser() ?? {},
    token:getUserToken() ?? '',
    loader:false,
    geoUser:{},
    hs_geom:''

};

const AuthReducer =   (state = initialState, action) => {
    switch (action.type)
    {
        case SET_LOADER:
            return {
                ...state,
                loader: action.payload
            }
        case HOUSING_SCHEME_BOUNDARY:
            return {
                ...state,
                hs_geom: action.payload
            }


        case AUTH_GEO_USER:
            return {
                ...state,
                geoUser: action.payload
            }

        case UPDATE_AUTH_USER :
            setLocalUser(action.payload)
            return  {
                ...state,
                user:action.payload
            }

        case AUTH_signout :
            console.log('signout hit',action)
            removeTokenUser()
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            return {
                ...state,
                user: {},
                token:''
            }

        case AUTH_LOGIN:
            const {payload} = action
            const {token,user} = payload
            setLocalUser(user)
            setToken(token)
            return {
                ...state,
                user,
                token,
                loader:false
            }
        case AUTH_LOGIN_ERROR:

            return {
                ...state
            }

        default:
            return state;
    }
}

export default AuthReducer